import { useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { requestParams } from './approvals_group_reducer';

const useSelectUserModal = (
  admins,
  approvers,
  users,
  adminsCount,
  approversCount,
  usersCount,
  adminsSelectionCount,
  approversSelectionCount,
  usersSelectionCount,
  approvalsGroupText,
  submitUserRequest,
  getUsersPath,
  usersRequestParams,
  approvalGroupDispatch,
  groupActions,
) => {
  const {
    admins: adminsText,
    approvers: approversText,
    users: usersText,
  } = approvalsGroupText;

  const createModalOptions = (
    role,
    usersList,
    userCount,
    modalSelectionCount,
    action,
  ) => {
    return {
      showModal: true,
      title: approvalsGroupText[role].title,
      cta: approvalsGroupText[role].cta,
      users: JSON.parse(JSON.stringify(usersList)),
      userCount,
      modalSelectionCount,
      currentSelectionCount: modalSelectionCount,
      selectAllUsers: userCount === modalSelectionCount,
      orderByName: false,
      orderByLimit: false,
      actionType: action,
    };
  };

  const openUserModal = userType => {
    switch (userType) {
      case adminsText.title: {
        const adminModalOptions = createModalOptions(
          'admins',
          admins,
          adminsCount,
          adminsSelectionCount,
          groupActions.UPDATE_ALL_ADMINS,
        );
        if (admins.length === 0) {
          approvalGroupDispatch({
            type: groupActions.UPDATE_USERS_REQUEST,
            payload: {
              usersRequestParams: requestParams.ADMINS_ROLE,
              userModal: adminModalOptions,
            },
          });
        } else {
          approvalGroupDispatch({
            type: groupActions.CREATE_USER_MODAL,
            payload: adminModalOptions,
          });
        }
        break;
      }
      case approversText.title: {
        const approverModalOptions = createModalOptions(
          'approvers',
          approvers,
          approversCount,
          approversSelectionCount,
          groupActions.UPDATE_ALL_APPROVERS,
        );
        if (approvers.length === 0) {
          approvalGroupDispatch({
            type: groupActions.UPDATE_USERS_REQUEST,
            payload: {
              usersRequestParams: requestParams.APPROVERS_ROLE,
              userModal: approverModalOptions,
            },
          });
        } else {
          approvalGroupDispatch({
            type: groupActions.CREATE_USER_MODAL,
            payload: approverModalOptions,
          });
        }
        break;
      }
      case usersText.title: {
        const userModalOptions = createModalOptions(
          'users',
          users,
          usersCount + approversCount,
          usersSelectionCount,
          groupActions.UPDATE_ALL_USERS,
        );
        if (users.length === 0) {
          approvalGroupDispatch({
            type: groupActions.UPDATE_USERS_REQUEST,
            payload: {
              usersRequestParams: requestParams.USERS_ROLE,
              userModal: userModalOptions,
            },
          });
        } else {
          approvalGroupDispatch({
            type: groupActions.CREATE_USER_MODAL,
            payload: userModalOptions,
          });
        }
        break;
      }
      default:
    }
  };

  const closeUserModal = () => {
    approvalGroupDispatch({ type: groupActions.RESET_USER_MODAL });
  };

  // ---- REQUEST USERS ---- //

  const { data: usersHttpData, error: usersHttpError } = useHTTP({
    url: submitUserRequest ? `${getUsersPath}${usersRequestParams}` : null,
  });

  useEffect(() => {
    if (usersHttpError === undefined) return;
    approvalGroupDispatch({ type: groupActions.ERROR_USERS_REQUEST });
  }, [usersHttpError]);

  useEffect(() => {
    if (usersHttpData === undefined) return;

    if (usersHttpData.approval_group_users) {
      approvalGroupDispatch({
        type: groupActions.ADD_USERS_REQUEST,
        payload: usersHttpData.approval_group_users,
      });
    }
  }, [usersHttpData]);

  return { openUserModal, closeUserModal };
};

export default useSelectUserModal;
